var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTeamactive = function SvgTeamactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.999,
    cy: 9.509,
    r: 3.491,
    fill: "url(#teamactive_svg__a)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.003,
    cy: 10.499,
    r: 2.501,
    fill: "url(#teamactive_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.996 21.003v-1.017C2.996 17.785 4.78 16 6.981 16h4.035a3.984 3.984 0 0 1 3.985 3.985v1.017M18.002 16.001h1.103c2.2 0 3.985 1.784 3.985 3.985v1.017"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "teamactive_svg__a",
    x1: 8.999,
    x2: 8.999,
    y1: 6.017,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6EDFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "teamactive_svg__b",
    x1: 18.003,
    x2: 18.003,
    y1: 7.998,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6EDFF",
    stopOpacity: 0
  })))));
};
export { SvgTeamactive as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiM2NmOGU5NTg3ZGVhMzM2ZWYxZTIzNGIyYTQ3YTMzYjIuc3ZnIjs=";